import {gridSlider} from '../features/grid-slider';
import {register} from '../vendor/theme-scripts/theme-sections';

register('subcollections', gridSlider);
